type CustomCaseApiLocale = "en" | "fr" | "es" | "de" | "it";

const RESPONSE_CODE_COPY: Record<CustomCaseApiLocale, Record<string, string>> = {
  en: {
    owner_verification_required: "Verify your order email to continue.",
    missing_access_token: "We couldn't verify this private custom case link.",
    custom_order_not_found: "This custom case could not be found.",
    invalid_owner_email: "A valid order email is required before we can send a code.",
    owner_email_mismatch: "This email does not match the order owner.",
    verification_code_rate_limited: "Please wait a moment before requesting another code.",
    invalid_access_code: "Enter the 6-digit access code.",
    expired_access_code: "This access code has expired. Request a new one.",
    incorrect_access_code: "The access code is incorrect.",
    payment_required: "Complete payment before opening this custom order.",
    payment_not_confirmed: "Complete payment before continuing with this custom case.",
    case_not_ready: "This case is not ready yet.",
    generated_case_not_found: "The generated case could not be found.",
    invalid_intake: "Review the intake details and fix the highlighted fields.",
    invalid_intake_draft: "This intake contains unsupported text. Review it and try again.",
    missing_city: "Add a city before generating case ideas.",
    initial_ideas_required: "Generate the first three ideas before requesting more.",
    idea_refresh_unavailable: "This order already has a selected idea queued for build.",
    ideas_limit_reached: "This order already has the maximum number of idea options.",
    additional_unique_ideas_unavailable: "We couldn't find three more distinct case directions right now.",
    missing_idea_id: "Choose a case concept before continuing.",
    selected_idea_not_found: "That case concept is no longer available.",
    casegen_webhook_missing: "Custom case generation is not configured yet.",
    casegen_webhook_failed: "Custom case generation could not be started. Please try again shortly.",
    invalid_generation_restart_state: "This build cannot be restarted from its current state.",
    missing_selected_idea: "Select an idea before restarting the build.",
    invalid_share_link_mode: "This guest-link setup is not available.",
    case_not_ready_to_share: "This case is not ready to share yet.",
    share_link_limit_reached: "Close or revoke an existing guest link before creating another one.",
    share_link_not_found: "That guest link could not be found.",
    missing_share_link_id: "Choose a guest link before revoking it.",
    route_not_found: "That private case route could not be found.",
    invalid_suspect_index: "Choose a valid suspect before submitting a warrant.",
    invalid_warrant: "We couldn't save that warrant right now.",
  },
  fr: {
    owner_verification_required: "Verifiez l'email de la commande pour continuer.",
    missing_access_token: "Nous n'avons pas pu verifier ce lien prive vers le dossier personnalise.",
    custom_order_not_found: "Ce dossier personnalise est introuvable.",
    invalid_owner_email: "Un email de commande valide est requis avant d'envoyer un code.",
    owner_email_mismatch: "Cet email ne correspond pas au proprietaire de la commande.",
    verification_code_rate_limited: "Patientez un instant avant de demander un nouveau code.",
    invalid_access_code: "Saisissez le code d'acces a 6 chiffres.",
    expired_access_code: "Ce code d'acces a expire. Demandez-en un nouveau.",
    incorrect_access_code: "Le code d'acces est incorrect.",
    payment_required: "Terminez le paiement avant d'ouvrir cette commande personnalisee.",
    payment_not_confirmed: "Terminez le paiement avant de continuer avec ce dossier personnalise.",
    case_not_ready: "Ce dossier n'est pas encore pret.",
    generated_case_not_found: "Le dossier genere est introuvable.",
    invalid_intake: "Revisez le formulaire et corrigez les champs signales.",
    invalid_intake_draft: "Ce formulaire contient du texte non pris en charge. Revisez-le puis reessayez.",
    missing_city: "Ajoutez une ville avant de generer des idees de dossier.",
    initial_ideas_required: "Generez d'abord les trois premieres idees avant d'en demander d'autres.",
    idea_refresh_unavailable: "Cette commande a deja une idee selectionnee en attente de production.",
    ideas_limit_reached: "Cette commande a deja atteint le nombre maximal d'idees.",
    additional_unique_ideas_unavailable:
      "Nous n'avons pas trouve trois nouvelles directions de dossier suffisamment differentes pour le moment.",
    missing_idea_id: "Choisissez un concept de dossier avant de continuer.",
    selected_idea_not_found: "Ce concept de dossier n'est plus disponible.",
    casegen_webhook_missing: "La generation du dossier personnalise n'est pas encore configuree.",
    casegen_webhook_failed: "La generation du dossier personnalise n'a pas pu demarrer. Reessayez dans un instant.",
    invalid_generation_restart_state: "Cette construction ne peut pas etre relancee depuis son etat actuel.",
    missing_selected_idea: "Selectionnez une idee avant de relancer la construction.",
    invalid_share_link_mode: "Cette configuration de lien invite n'est pas disponible.",
    case_not_ready_to_share: "Ce dossier n'est pas encore pret a etre partage.",
    share_link_limit_reached: "Fermez ou revoquez un lien invite existant avant d'en creer un autre.",
    share_link_not_found: "Ce lien invite est introuvable.",
    missing_share_link_id: "Choisissez un lien invite avant de le revoquer.",
    route_not_found: "Cette route privee du dossier est introuvable.",
    invalid_suspect_index: "Choisissez un suspect valide avant d'envoyer l'accusation.",
    invalid_warrant: "Nous n'avons pas pu enregistrer cette accusation pour le moment.",
  },
  es: {
    owner_verification_required: "Verifica el correo del pedido para continuar.",
    missing_access_token: "No pudimos verificar este enlace privado del caso personalizado.",
    custom_order_not_found: "No se encontro este caso personalizado.",
    invalid_owner_email: "Se necesita un correo valido del pedido antes de enviar un codigo.",
    owner_email_mismatch: "Este correo no coincide con el propietario del pedido.",
    verification_code_rate_limited: "Espera un momento antes de solicitar otro codigo.",
    invalid_access_code: "Introduce el codigo de acceso de 6 digitos.",
    expired_access_code: "Este codigo de acceso ha caducado. Solicita uno nuevo.",
    incorrect_access_code: "El codigo de acceso es incorrecto.",
    payment_required: "Completa el pago antes de abrir este pedido personalizado.",
    payment_not_confirmed: "Completa el pago antes de continuar con este caso personalizado.",
    case_not_ready: "Este caso aun no esta listo.",
    generated_case_not_found: "No se encontro el caso generado.",
    invalid_intake: "Revisa el formulario y corrige los campos marcados.",
    invalid_intake_draft: "Este formulario contiene texto no admitido. Revisalo y vuelve a intentarlo.",
    missing_city: "Anade una ciudad antes de generar ideas para el caso.",
    initial_ideas_required: "Genera primero las tres ideas iniciales antes de pedir mas.",
    idea_refresh_unavailable: "Este pedido ya tiene una idea seleccionada en cola para construirse.",
    ideas_limit_reached: "Este pedido ya tiene el numero maximo de ideas.",
    additional_unique_ideas_unavailable:
      "No pudimos encontrar tres nuevas direcciones de caso suficientemente distintas ahora mismo.",
    missing_idea_id: "Elige un concepto de caso antes de continuar.",
    selected_idea_not_found: "Ese concepto de caso ya no esta disponible.",
    casegen_webhook_missing: "La generacion del caso personalizado todavia no esta configurada.",
    casegen_webhook_failed: "No se pudo iniciar la generacion del caso personalizado. Vuelve a intentarlo enseguida.",
    invalid_generation_restart_state: "Esta generacion no se puede reiniciar desde su estado actual.",
    missing_selected_idea: "Selecciona una idea antes de reiniciar la generacion.",
    invalid_share_link_mode: "Esta configuracion del enlace de invitado no esta disponible.",
    case_not_ready_to_share: "Este caso todavia no esta listo para compartirse.",
    share_link_limit_reached: "Cierra o revoca un enlace de invitado existente antes de crear otro.",
    share_link_not_found: "No se encontro ese enlace de invitado.",
    missing_share_link_id: "Elige un enlace de invitado antes de revocarlo.",
    route_not_found: "No se encontro esa ruta privada del caso.",
    invalid_suspect_index: "Elige un sospechoso valido antes de enviar la acusacion.",
    invalid_warrant: "No pudimos guardar esa acusacion ahora mismo.",
  },
  de: {
    owner_verification_required: "Bestatigen Sie die Bestell-E-Mail, um fortzufahren.",
    missing_access_token: "Wir konnten diesen privaten Link zum individuellen Fall nicht verifizieren.",
    custom_order_not_found: "Dieser individuelle Fall wurde nicht gefunden.",
    invalid_owner_email: "Bevor wir einen Code senden, wird eine gultige Bestell-E-Mail benotigt.",
    owner_email_mismatch: "Diese E-Mail stimmt nicht mit dem Bestellinhaber uberein.",
    verification_code_rate_limited: "Bitte warten Sie einen Moment, bevor Sie einen neuen Code anfordern.",
    invalid_access_code: "Geben Sie den 6-stelligen Zugangscode ein.",
    expired_access_code: "Dieser Zugangscode ist abgelaufen. Fordern Sie einen neuen an.",
    incorrect_access_code: "Der Zugangscode ist falsch.",
    payment_required: "Schliessen Sie die Zahlung ab, bevor Sie diese individuelle Bestellung offnen.",
    payment_not_confirmed: "Schliessen Sie die Zahlung ab, bevor Sie mit diesem individuellen Fall fortfahren.",
    case_not_ready: "Dieser Fall ist noch nicht bereit.",
    generated_case_not_found: "Der generierte Fall wurde nicht gefunden.",
    invalid_intake: "Prufen Sie den Fragebogen und korrigieren Sie die markierten Felder.",
    invalid_intake_draft: "Dieser Fragebogen enthalt nicht unterstutzten Text. Prufen Sie ihn und versuchen Sie es erneut.",
    missing_city: "Fugen Sie eine Stadt hinzu, bevor Sie Fallideen generieren.",
    initial_ideas_required: "Erzeugen Sie zuerst die ersten drei Ideen, bevor Sie weitere anfordern.",
    idea_refresh_unavailable: "Diese Bestellung hat bereits eine ausgewahlte Idee, die zum Build eingeplant ist.",
    ideas_limit_reached: "Diese Bestellung hat bereits die maximale Anzahl an Ideen erreicht.",
    additional_unique_ideas_unavailable:
      "Wir konnten im Moment keine drei weiteren klar unterschiedlichen Fallrichtungen finden.",
    missing_idea_id: "Wahlen Sie ein Fallkonzept, bevor Sie fortfahren.",
    selected_idea_not_found: "Dieses Fallkonzept ist nicht mehr verfugbar.",
    casegen_webhook_missing: "Die Generierung des individuellen Falls ist noch nicht konfiguriert.",
    casegen_webhook_failed:
      "Die Generierung des individuellen Falls konnte nicht gestartet werden. Bitte versuchen Sie es gleich noch einmal.",
    invalid_generation_restart_state: "Dieser Build kann aus seinem aktuellen Zustand nicht neu gestartet werden.",
    missing_selected_idea: "Wahlen Sie eine Idee aus, bevor Sie den Build neu starten.",
    invalid_share_link_mode: "Diese Gastlink-Konfiguration ist nicht verfugbar.",
    case_not_ready_to_share: "Dieser Fall ist noch nicht zum Teilen bereit.",
    share_link_limit_reached: "Schliessen oder widerrufen Sie einen bestehenden Gastlink, bevor Sie einen weiteren erstellen.",
    share_link_not_found: "Dieser Gastlink wurde nicht gefunden.",
    missing_share_link_id: "Wahlen Sie einen Gastlink aus, bevor Sie ihn widerrufen.",
    route_not_found: "Diese private Fallroute wurde nicht gefunden.",
    invalid_suspect_index: "Wahlen Sie einen gultigen Verdachtigen, bevor Sie den Haftbefehl absenden.",
    invalid_warrant: "Wir konnten diesen Haftbefehl im Moment nicht speichern.",
  },
  it: {
    owner_verification_required: "Verifica l'email dell'ordine per continuare.",
    missing_access_token: "Non siamo riusciti a verificare questo link privato del caso personalizzato.",
    custom_order_not_found: "Questo caso personalizzato non e stato trovato.",
    invalid_owner_email: "Serve un'email ordine valida prima di inviare un codice.",
    owner_email_mismatch: "Questa email non corrisponde al proprietario dell'ordine.",
    verification_code_rate_limited: "Attendi un momento prima di richiedere un nuovo codice.",
    invalid_access_code: "Inserisci il codice di accesso di 6 cifre.",
    expired_access_code: "Questo codice di accesso e scaduto. Richiedine uno nuovo.",
    incorrect_access_code: "Il codice di accesso non e corretto.",
    payment_required: "Completa il pagamento prima di aprire questo ordine personalizzato.",
    payment_not_confirmed: "Completa il pagamento prima di continuare con questo caso personalizzato.",
    case_not_ready: "Questo caso non e ancora pronto.",
    generated_case_not_found: "Il caso generato non e stato trovato.",
    invalid_intake: "Rivedi il modulo e correggi i campi evidenziati.",
    invalid_intake_draft: "Questo modulo contiene testo non supportato. Rivedilo e riprova.",
    missing_city: "Aggiungi una citta prima di generare idee per il caso.",
    initial_ideas_required: "Genera prima le prime tre idee prima di richiederne altre.",
    idea_refresh_unavailable: "Questo ordine ha gia un'idea selezionata in coda per la produzione.",
    ideas_limit_reached: "Questo ordine ha gia il numero massimo di idee disponibili.",
    additional_unique_ideas_unavailable:
      "Non siamo riusciti a trovare altre tre direzioni del caso abbastanza diverse in questo momento.",
    missing_idea_id: "Scegli un concetto di caso prima di continuare.",
    selected_idea_not_found: "Questo concetto di caso non e piu disponibile.",
    casegen_webhook_missing: "La generazione del caso personalizzato non e ancora configurata.",
    casegen_webhook_failed:
      "Non e stato possibile avviare la generazione del caso personalizzato. Riprova tra poco.",
    invalid_generation_restart_state: "Questa build non puo essere riavviata dal suo stato attuale.",
    missing_selected_idea: "Seleziona un'idea prima di riavviare la build.",
    invalid_share_link_mode: "Questa configurazione del link ospite non e disponibile.",
    case_not_ready_to_share: "Questo caso non e ancora pronto per essere condiviso.",
    share_link_limit_reached: "Chiudi o revoca un link ospite esistente prima di crearne un altro.",
    share_link_not_found: "Questo link ospite non e stato trovato.",
    missing_share_link_id: "Scegli un link ospite prima di revocarlo.",
    route_not_found: "Questa route privata del caso non e stata trovata.",
    invalid_suspect_index: "Scegli un sospetto valido prima di inviare l'accusa.",
    invalid_warrant: "Non siamo riusciti a salvare questa accusa in questo momento.",
  },
};

const RESPONSE_MESSAGE_COPY: Record<CustomCaseApiLocale, Record<string, string>> = {
  en: {
    "Verify your email to continue.": "Verify your order email to continue.",
    "A valid email is required to send an access code.":
      "A valid order email is required before we can send a code.",
    "That email does not match this custom order.": "This email does not match the order owner.",
    "Please wait a moment before requesting another code.":
      "Please wait a moment before requesting another code.",
    "This access code has expired. Request a new one.":
      "This access code has expired. Request a new one.",
    "The access code is incorrect.": "The access code is incorrect.",
    "Custom order not found": "This custom case could not be found.",
    "Custom order not found.": "This custom case could not be found.",
    "Custom case generation could not be restarted. Please try again shortly.":
      "Custom case generation could not be restarted. Please try again shortly.",
    "The case is not ready for a warrant yet.": "This case is not ready yet.",
    "The custom case is not ready yet.": "This case is not ready yet.",
  },
  fr: {
    "Verify your email to continue.": "Verifiez l'email de la commande pour continuer.",
    "A valid email is required to send an access code.":
      "Un email de commande valide est requis avant d'envoyer un code.",
    "That email does not match this custom order.":
      "Cet email ne correspond pas au proprietaire de la commande.",
    "Please wait a moment before requesting another code.":
      "Patientez un instant avant de demander un nouveau code.",
    "This access code has expired. Request a new one.":
      "Ce code d'acces a expire. Demandez-en un nouveau.",
    "The access code is incorrect.": "Le code d'acces est incorrect.",
    "Custom order not found": "Ce dossier personnalise est introuvable.",
    "Custom order not found.": "Ce dossier personnalise est introuvable.",
    "Custom case generation could not be restarted. Please try again shortly.":
      "La generation du dossier personnalise n'a pas pu etre relancee. Reessayez dans un instant.",
    "The case is not ready for a warrant yet.": "Ce dossier n'est pas encore pret.",
    "The custom case is not ready yet.": "Ce dossier n'est pas encore pret.",
  },
  es: {
    "Verify your email to continue.": "Verifica el correo del pedido para continuar.",
    "A valid email is required to send an access code.":
      "Se necesita un correo valido del pedido antes de enviar un codigo.",
    "That email does not match this custom order.":
      "Este correo no coincide con el propietario del pedido.",
    "Please wait a moment before requesting another code.":
      "Espera un momento antes de solicitar otro codigo.",
    "This access code has expired. Request a new one.":
      "Este codigo de acceso ha caducado. Solicita uno nuevo.",
    "The access code is incorrect.": "El codigo de acceso es incorrecto.",
    "Custom order not found": "No se encontro este caso personalizado.",
    "Custom order not found.": "No se encontro este caso personalizado.",
    "Custom case generation could not be restarted. Please try again shortly.":
      "No se pudo reiniciar la generacion del caso personalizado. Vuelve a intentarlo enseguida.",
    "The case is not ready for a warrant yet.": "Este caso aun no esta listo.",
    "The custom case is not ready yet.": "Este caso aun no esta listo.",
  },
  de: {
    "Verify your email to continue.": "Bestatigen Sie die Bestell-E-Mail, um fortzufahren.",
    "A valid email is required to send an access code.":
      "Bevor wir einen Code senden, wird eine gultige Bestell-E-Mail benotigt.",
    "That email does not match this custom order.":
      "Diese E-Mail stimmt nicht mit dem Bestellinhaber uberein.",
    "Please wait a moment before requesting another code.":
      "Bitte warten Sie einen Moment, bevor Sie einen neuen Code anfordern.",
    "This access code has expired. Request a new one.":
      "Dieser Zugangscode ist abgelaufen. Fordern Sie einen neuen an.",
    "The access code is incorrect.": "Der Zugangscode ist falsch.",
    "Custom order not found": "Dieser individuelle Fall wurde nicht gefunden.",
    "Custom order not found.": "Dieser individuelle Fall wurde nicht gefunden.",
    "Custom case generation could not be restarted. Please try again shortly.":
      "Die Generierung des individuellen Falls konnte nicht neu gestartet werden. Bitte versuchen Sie es gleich noch einmal.",
    "The case is not ready for a warrant yet.": "Dieser Fall ist noch nicht bereit.",
    "The custom case is not ready yet.": "Dieser Fall ist noch nicht bereit.",
  },
  it: {
    "Verify your email to continue.": "Verifica l'email dell'ordine per continuare.",
    "A valid email is required to send an access code.":
      "Serve un'email ordine valida prima di inviare un codice.",
    "That email does not match this custom order.":
      "Questa email non corrisponde al proprietario dell'ordine.",
    "Please wait a moment before requesting another code.":
      "Attendi un momento prima di richiedere un nuovo codice.",
    "This access code has expired. Request a new one.":
      "Questo codice di accesso e scaduto. Richiedine uno nuovo.",
    "The access code is incorrect.": "Il codice di accesso non e corretto.",
    "Custom order not found": "Questo caso personalizzato non e stato trovato.",
    "Custom order not found.": "Questo caso personalizzato non e stato trovato.",
    "Custom case generation could not be restarted. Please try again shortly.":
      "Non e stato possibile riavviare la generazione del caso personalizzato. Riprova tra poco.",
    "The case is not ready for a warrant yet.": "Questo caso non e ancora pronto.",
    "The custom case is not ready yet.": "Questo caso non e ancora pronto.",
  },
};

const RESPONSE_MESSAGE_CODE_FALLBACKS: Record<string, string> = {
  "A valid email is required to send an access code.": "invalid_owner_email",
  "That email does not match this custom order.": "owner_email_mismatch",
  "Please wait a moment before requesting another code.": "verification_code_rate_limited",
  "Enter the 6-digit access code.": "invalid_access_code",
  "This access code has expired. Request a new one.": "expired_access_code",
  "The access code is incorrect.": "incorrect_access_code",
  "Payment has not been confirmed for this order yet.": "payment_not_confirmed",
  "Custom order intake is incomplete.": "invalid_intake",
  "Custom order intake contains unsupported text.": "invalid_intake_draft",
  "Custom order intake contains unsupported or unsafe text.": "invalid_intake_draft",
  "Custom order intake must include city before idea generation.": "missing_city",
  "Generate the first three ideas before requesting more.": "initial_ideas_required",
  "This order already has the maximum number of custom-case ideas.": "ideas_limit_reached",
  "Unable to generate three new unique custom-case ideas right now.": "additional_unique_ideas_unavailable",
  "Selected idea was not found on this custom order.": "selected_idea_not_found",
  "Only failed custom case builds can be restarted.": "invalid_generation_restart_state",
  "This custom order no longer has a selected idea to restart.": "missing_selected_idea",
  "This custom order no longer has a selected idea to rerun.": "missing_selected_idea",
  "Unsupported share-link mode.": "invalid_share_link_mode",
  "The custom case is not ready to share yet.": "case_not_ready_to_share",
  "Guest link not found": "share_link_not_found",
  "Guest link not found.": "share_link_not_found",
  "Route not found": "route_not_found",
  "Route not found.": "route_not_found",
  "Generated case not found": "generated_case_not_found",
  "Generated case not found.": "generated_case_not_found",
  "Selected suspect is invalid.": "invalid_suspect_index",
};

const resolveCustomCaseApiLocale = (value = ""): CustomCaseApiLocale => {
  const normalized = String(value || "").trim().toLowerCase();
  if (normalized === "fr") return "fr";
  if (normalized === "es") return "es";
  if (normalized === "de") return "de";
  if (normalized === "it") return "it";
  return "en";
};

export const getLocalizedCustomCaseApiMessage = ({
  error,
  locale,
  fallback,
}: {
  error: any;
  locale?: string;
  fallback: string;
}) => {
  const resolvedLocale = resolveCustomCaseApiLocale(locale);
  const responseCode = String(error?.response?.data?.code || "").trim();
  if (responseCode && RESPONSE_CODE_COPY[resolvedLocale]?.[responseCode]) {
    return RESPONSE_CODE_COPY[resolvedLocale][responseCode];
  }

  const responseMessage = String(
    error?.response?.data?.message || error?.response?.data?.error || "",
  ).trim();
  const responseMessageCode = RESPONSE_MESSAGE_CODE_FALLBACKS[responseMessage];
  if (responseMessageCode && RESPONSE_CODE_COPY[resolvedLocale]?.[responseMessageCode]) {
    return RESPONSE_CODE_COPY[resolvedLocale][responseMessageCode];
  }

  if (responseMessage && RESPONSE_MESSAGE_COPY[resolvedLocale]?.[responseMessage]) {
    return RESPONSE_MESSAGE_COPY[resolvedLocale][responseMessage];
  }

  return responseMessage || String(error?.message || "").trim() || fallback;
};
